<script lang="ts">
    import { RuleEngine } from "../RuleEngine"

    let { value = $bindable(), dependsOn, label, placeholder, values = $bindable() }: FieldComponentProps = $props()
    values = values || null

    const ruleEngine = new RuleEngine()
    let displayComponent: boolean = $state(true)

    $effect(() => {
        if (values && dependsOn) {
            displayComponent = ruleEngine.resolve(dependsOn, values)
            if (!displayComponent) value = null
        }
    })
</script>

{#if displayComponent}
    <div class="textarea-input">
        {#if label}
            <label for="">{label}</label>
        {/if}
        <textarea bind:value {placeholder}></textarea>
    </div>
{/if}
